module.exports = __webpack_public_path__ + "5bae45a094aabbc7d591ac6e735c8117.svg";